import { Injectable } from '@angular/core';
import { IBlobOverview } from '../../../../shared/models/blob-overview';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { IBlobFile } from '../../../../shared/models/blob-file';
import { IApiResponse } from '../../../../shared/models/api-response';

@Injectable({
  providedIn: 'root'
})
export class GuidesAndVideosService {

  baseUrl: string = `${environment.servicesUrl.ballot}api/userguides`;
  constructor(
    private http: HttpClient
  ) { }

  DownloadUserGuideAndVideo(containerName: string, blobName: string): Observable<IApiResponse<IBlobFile>> {
    return this.http.get<IApiResponse<IBlobFile>>(`${this.baseUrl}/DownloadUserGuideAndVideo/${containerName}/${blobName}`);
  }

  GetUserGuideAndVideoContainerContents(): Observable<IApiResponse<IBlobOverview[]>> {
    return this.http.get<IApiResponse<IBlobOverview[]>>(`${this.baseUrl}/GetUserGuideAndVideoContainerContents/`);
  }

  DownloadAsIso24495Document(): Observable<IApiResponse<string>> {
      return this.http.get<IApiResponse<string>>(`${this.baseUrl}/download-as-iso-24495-document`);
  }
}
 